var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:`p-4 text-center bg-${_vm.Theme === 'dark' ? 'gradient-dark' : 'white'}`},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — "),_c('a',{attrs:{"href":"https://softbusiness.com.co/","target":"_blank"}},[_vm._v("Softbusiness S.A.S")])])
}
var staticRenderFns = []

export { render, staticRenderFns }